import React from 'react';
interface EvidenceSectionProps {
  heading?: string;
  content: string;
}
export function EvidenceSection({
  heading = "Here's what the evidence shows.",
  content
}: EvidenceSectionProps) {
  // Parse content to highlight bold statistics (e.g., ~2–4 years, glycaemic control)
  const renderContent = () => {
    // Split by bold markers (assuming format like **text** or numbers/stats)
    const parts = content.split(/(\d+[–—-]\d+\s*(?:years|months|weeks|days)|~\d+[–—-]\d+\s*(?:years|months|weeks|days)|\d+%|\d+\s*(?:years|months|weeks))/g);
    return parts.map((part, index) => {
      // Check if part is a statistic
      if (/(\d+[–—-]\d+\s*(?:years|months|weeks|days)|~\d+[–—-]\d+\s*(?:years|months|weeks|days)|\d+%|\d+\s*(?:years|months|weeks))/.test(part)) {
        return <strong key={index} className="text-roche-blue font-bold text-lg" data-id="element-27">
            {part}
          </strong>;
      }
      return <span key={index} data-id="element-28">{part}</span>;
    });
  };
  return <div className="px-6 py-8" data-id="element-29">
      <h3 className="text-xl font-bold text-text-primary mb-6" data-id="element-30">{heading}</h3>

      <div className="prose prose-sm max-w-none" data-id="element-31">
        <p className="text-text-primary leading-relaxed text-base mb-4" data-id="element-32">
          {renderContent()}
        </p>
      </div>
    </div>;
}